<template>
  <v-card
    class="ma-0 mt-0 pt-0"
    width="100%"
    flat
  >
    <v-card-title class="pt-0">
      {{ $t('excelUpload') }} {{ $t(type) }}
    </v-card-title>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            v-if="digikalaProp"
          >
            <autocomplete
              v-model="digikalaPanel"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('digikalaPanelsName')"
              type="digikalaPanels"
            />
          </v-col>
          <v-col
            v-if="downloadLink"
            cols="12"
            class="py-0"
          >
            <a
              :href="downloadLink"
              download
              type="button"
              class="mt-2 v-btn v-btn--block v-btn--outlined theme--light v-size--small green--text"
            >
              {{ $t('sampleFile') }}
              <v-icon
                color="green"
                class="mx-1"
              >
                mdi-download
              </v-icon>
            </a>
          </v-col>
          <v-col class="pb-0">
            <v-btn
              color="primary"
              outlined
              style="width: 100%"
              height="32"
              :loading="isSelecting"
              @click="handleFileImport"
            >
              <v-icon left>
                mdi-upload
              </v-icon>
              {{ buttonText }}
            </v-btn>

            <!-- Create a File Input that will be hidden but triggered with JavaScript -->
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              @change="onFileChanged"
            >
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <dropbox
              v-model="file"
              :title="$t('addFile') + '(dropbox)'"
              :extensions="['.xlsx','.csv']"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      {{ $t('fileName') }}
                    </th>
                    <th>
                      {{ $t('status') }}
                    </th>
                    <th>
                      {{ $t('doneCountItem') }}
                    </th>
                    <th>
                      {{ $t('registerar') }}
                    </th>
                    <th>
                      {{ $t('time') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.id"
                  >
                    <td>{{ item.file.title }}</td>
                    <td>{{ $t(item.status) }}</td>
                    <td>{{ item.count_item }}</td>
                    <td>{{ item.user.firstname }}  {{ item.user.lastname }} </td>
                    <td>{{ item.time }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../../Mixins/general'
  import Snakbar from '../snakbar/snakbar'
  import Dropbox from '../../general/dropbox/index'
  export default {
    name: 'UploadDialog',
    components: {
      Snakbar,
      Dropbox,
    },
    mixins: [General],
    props: ['typeProp', 'getItem', 'digikalaProp'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      isSelecting: false,
      selectedFile: null,
      render: false,
      isLoading: false,
      alert: false,
      digikalaPanel: null,
      downloadLink: null,
      type: null,
      id: null,
      valid: null,
      items: null,
      file: null,
    }),
    computed: {
      buttonText () {
        return this.selectedFile ? this.selectedFile.name : this.$t('uploadFromSystem')
      },
    },
    watch: {
      getItem () {
        if (this.getItem) {
          this.getItems()
        }
      },
      typeProp () {
        this.type = this.typeProp
      },
    },
    beforeMount () {
    },
    mounted () {
      if (this.typeProp) {
        this.type = this.typeProp
        if (this.type === 'product') {
          this.downloadLink = '/sample/product.xlsx'
        }
        if (this.type === 'customer') {
          this.downloadLink = '/sample/customer.xlsx'
        }
        if (this.type === 'translationPrice') {
          this.downloadLink = '/sample/translation.xlsx'
        }
        if (this.type === 'accountStructure') {
          this.downloadLink = '/sample/accountStructure.xlsx'
        }
        if (this.type === 'accountingDocument') {
          this.downloadLink = '/sample/accountingDocument.xlsx'
        }
        if (this.type === 'invoice') {
          this.downloadLink = '/sample/invoice.xlsx'
        }
        if (this.type === 'entrepot') {
          this.downloadLink = '/sample/entrepot.xlsx'
        }
        if (this.type === 'pricing') {
          this.downloadLink = '/sample/pricing.xlsx'
        }
        if (this.type === 'warehouseHandling') {
          this.downloadLink = '/sample/warehouseHandling.xlsx'
        }
        if (this.type === 'production') {
          this.downloadLink = '/sample/production.xlsx'
        }
      }
      this.getItems()
    },
    methods: {
      create () {
        var app = this
        app.isLoading = true
        var formData = new FormData()
        formData.append('selectedFile', this.selectedFile)
        formData.append('ref_type', (this.digikalaPanel ? this.digikalaPanel.name : null))
        formData.append('file', this.file)
        formData.append('type', this.type)
        formData.append('items', this.items)
        app.$axios.post(this.$endpoint + 'import', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(res => {
            app.$emit('close')
            app.$emit('input', res.data)
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'import', {
          params: {
            getType: 'list',
            type: app.type,
          },
        })
          .then(res => {
            res = res.data
            app.items = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      handleFileImport () {
        this.isSelecting = true

        // After obtaining the focus when closing the FilePicker, return the button state to normal
        window.addEventListener('focus', () => {
          this.isSelecting = false
        }, { once: true })

        // Trigger click on the FileInput
        this.$refs.uploader.click()
      },
      onFileChanged (e) {
        this.selectedFile = e.target.files[0]
        // Do whatever you need with the file, liek reading it with FileReader
      },
    },
  }
</script>

<style scoped>

</style>
